// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"104":"3f8d1b58","144":"6fa414a2","501":"ffa7b2fb","874":"a64b862b","881":"a1f7bc5a","967":"3f8d1b58"}[chunkId] + ".chunk.css";
};